export default __webpack_public_path__ + "static/media/clothes.f82ba4a8.jpg";